import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Slider from "react-slick";
import { urls } from "../../../Routes/Urls";
import { getBestSellerBookPrice, getBookPrice, getRandomImageForBestSellerBook, removeUnpairedQuotes } from "../../../Util";
import Card from "../../BestSeller/Card/Card2";
import classes from "./Recommendations.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect, useState } from "react";
import { fetchSimilarBooks } from "../../../Store/actions/BookAction";
import { fetchBook } from "../../../Store/actions/BestSellerBookAction";

const itemsPerPage = 10;

function NextArrow(props) {
  const { onClick } = props;
  return (
    <div
      className={classes.leftArrow}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faAngleRight} />
    </div>
  );
}
function PrevArrow(props) {
  const { onClick } = props;
  return (
    <div
      className={classes.RightArrow}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faAngleLeft} />
    </div>
  );
}

const Recommendations = ({book}) => {

  useEffect(() => {
    if(book?.id) {
      fetchSuggestions()
    }
  },[book])

  const wishlist = useSelector((state) => state.wishlist.wishlistItems);
  const history = useHistory()
  
    const getFilter = (query,selectedGenres) => {
      const currPage = 1;
      let filter = {
        limit: itemsPerPage,
        offset: (currPage - 1) * itemsPerPage,
        where: {
          $or: [],
        },
      };
  
      if (query) {
        // Add field and query conditions
          let updatedQuery = removeUnpairedQuotes(query);
          updatedQuery = `"${updatedQuery}"`
          filter.where.$or.push({ "author": updatedQuery });
      }
  
      if (selectedGenres?.length > 0) {
        filter.where.$or.push({ genres: selectedGenres.join(",") });
      }
  
      return filter;
    };

  const [suggestions,setSuggestions] = useState([]);

  const fetchSuggestions = async () => {
    const filter = getFilter(book?.author, book?.genres);
  
    const bookResponse = await fetchSimilarBooks("author", book?.author, itemsPerPage, 1, book?.genres);
    const bestSellerResponse = await fetchBook(null, filter);
  
    // Filter out books with the same title as the current book
    const bookSuggestions = bookResponse?.data
      ?.filter(suggestion => suggestion.title !== book?.title)
      ?.map(book => ({ ...book, isBestSeller: false })) ?? [];
  
    // Filter out bestsellers with the same title as current book
    const bestSellerSuggestions = bestSellerResponse?.data
      ?.filter(suggestion => suggestion.title !== book?.title)
      ?.map(book => ({ ...book, isBestSeller: true })) ?? [];
  
    // Create a Set of titles we've already added to suggestions
    const uniqueTitles = new Set();
    const uniqueSuggestions = [];

        // Then add bestSellerSuggestions if their title isn't already in the set
    bestSellerSuggestions.forEach(suggestion => {
      if (!uniqueTitles.has(suggestion.title)) {
        uniqueTitles.add(suggestion.title);
        uniqueSuggestions.push(suggestion);
      }
    });
  
    // Add bookSuggestions first (prioritized)
    bookSuggestions.forEach(suggestion => {
      if (!uniqueTitles.has(suggestion.title)) {
        uniqueTitles.add(suggestion.title);
        uniqueSuggestions.push(suggestion);
      }
    });
  
    setSuggestions(uniqueSuggestions);
  }

  const handleOnClick = (book) => {
    if(book?.isBestSeller) {
      const searchParam = new URLSearchParams();
      searchParam.set("color",book?.color)
      history.push(
        {pathname:`${urls.BESTSELLERPDP}/${book.id}/${book?.title_slug}`,search:searchParam ? `?${searchParam}` : "", state: {book}});
    } else {
      const searchParam = new URLSearchParams();
      searchParam.set("variantType",book?.variantType)
      searchParam.set("leatherType",book?.leatherType)
      searchParam.set("color",book?.color)
      history.push({pathname:`${urls.PRODUCTDETAIL}/${book.sku}/${book?.title_slug}`,search:searchParam ? `?${searchParam}` : "", state: {book}});
    }
  };

  const getRedirectUrl = (book) => {
    if (book?.isBestSeller) {
      const baseUrl = `${urls.BESTSELLERPDP}/${book.id}/${book?.title_slug}`;
      const searchParams = new URLSearchParams();
      searchParams.set('color', book?.color);
      const queryString = searchParams.toString();
      return queryString ? `${baseUrl}?${queryString}` : baseUrl;
    } else {
      const baseUrl = `${urls.PRODUCTDETAIL}/${book.id}/${book?.title_slug}`;
          const searchParams = new URLSearchParams();
          
          searchParams.set('leatherType', book?.leatherType);
          searchParams.set('variantType', book?.variantType);
          searchParams.set('color', book?.color);
          
          const queryString = searchParams.toString();
          return queryString ? `${baseUrl}?${queryString}` : baseUrl;
    }
  };

  const isWishListItem = (bookData) => {
    const bookOpt = wishlist?.find((item) => item?.book?.sku === bookData.sku && item?.book?.title === bookData?.title)
    if(bookOpt) {
      return {isPresent : true, data: bookOpt}
    } else {
      return {isPresent : false, data:null}
    }
  }

  const allColorsData = useSelector((state) => state.bookColor.colors);

  const settings = {
    dots: false,
    arrows: true,
    autoplay: false,
    accessibility: true,
    infinite: false,
    speed: 500,
    slidesToShow: suggestions?.length < 4.5 ? suggestions?.length : 4.5,
    slidesToScroll: 1,
    centerMode: false,
    focusOnSelect: true,
    centerPadding: "0px",
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 376,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };


  return (
    <div className={classes.container}>
      <h2>You may also like these books</h2>
      {suggestions.length > 0 && <div className={classes.carouselContainer}>
        <Slider className={classes.slider} {...settings}>
          {suggestions.map((book, index) => (
            <Card
              key={index}
              bookData={book}
              isWishListItem={isWishListItem(book)?.isPresent}
              wishlistItemId={isWishListItem(book)?.data?.id}
              onClick={() => handleOnClick(book)}
              redirectUrl={getRedirectUrl(book)}
              image={book?.imageUrl || getRandomImageForBestSellerBook(book,allColorsData)?.image}
              price={book?.isBestSeller ? getBestSellerBookPrice(book,"realLeather") : getBookPrice(book,book?.leatherType,book?.variantType)}
            />
          ))}
        </Slider>

        {/* <BookCarousel /> */}
      </div>}
    </div>
  );
};

export default Recommendations;
